var noCase = require('no-case');
/**
 * Param case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */


module.exports = function (value, locale) {
  return noCase(value, locale, '-');
};